<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { faCopy } from '@fortawesome/duotone-regular-svg-icons'
import { AuToast } from '~/stores/toasts'
import { PendoFeature } from '~/models/Pendo'
import { useClipboardApi } from '~/composables/useClipboardApi'
import Button from '~/components/ui/Button.vue'

const { url } = defineProps<{ url: string }>()

const { t } = useI18n()
const { writeToClipboard } = useClipboardApi()

const relevantUrl = computed(() => url.startsWith('/')
  ? `${import.meta.env.VITE_HOST}${url}`
  : url)

const activateCopy = () => {
  try {
    writeToClipboard({ text: relevantUrl.value })
    AuToast.success({
      title: t('copy.messages.success'),
      duration: 3000,
    })
  } catch (e) {
    AuToast.error({
      title: t('copy.messages.error'),
      duration: 5000,
    })
    throw e
  }
}
</script>

<template>
  <Button
    v-bind="$attrs"
    :data-pendo="PendoFeature.Card.CopyUrl"
    variant="ghost"
    full-width
    size="lg"
    @click.prevent="activateCopy"
  >
    <font-awesome-icon :icon="faCopy" />
    {{ t('copy.copyUrl') }}
  </Button>
</template>
